import React from "react"
import { IJobConsolidatedTimecard } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui/Table"
import { Paper, Avatar } from "material-ui"
import ConsolidatedTimecardEmployeeInnerTable from "./ConsolidatedTimecardEmployeeInnerTable"
import ImageTimer from "material-ui/svg-icons/image/timer"
import ImageLoader from "../../../components/misc/ImageLoader"
import ExternalLink from "../../../components/common/externalLink/ExternalLink"
import * as userHelper from "../../../helpers/userHelper"
import Person from "material-ui/svg-icons/social/person"

interface IProps {
    consolidatedTimecards: IJobConsolidatedTimecard[]
    handleOpenTimecardPopup(employeeId): void
}

const ConsolidatedTimecardEmployeeTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ marginTop: 10 }}>
            <Paper zDepth={1} style={{ padding: 15, marginTop: 15 }}>
                <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 10, marginBottom: 10 }}>{strings.Employee_Details}</span>
                <Table style={{ marginTop: 10 }}>
                    <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false} style={{ borderTop: "1px solid #9E9E9E" }}>
                        {props.consolidatedTimecards.map((timecard, index) =>
                            <TableRow
                                key={index}
                                data-intercom-target={`Select${index}`}
                                style={{ borderTop: "1px solid #9E9E9E", borderBottom: "none" }}
                            >
                                <TableRowColumn style={{ width: 150, paddingLeft: 0, paddingRight: 0, verticalAlign: "initial" }}>
                                    <div>
                                        <div style={{ height: 100, marginTop: 20, marginBottom: 5, marginLeft: 5 }}>
                                            {(timecard.ProfileImageS3Url || timecard.ProfileImageID) ?
                                                <ImageLoader url={timecard.ProfileImageS3Url} fixedHeight={175} avatar={true} src={"/users/profileimage/" + timecard.ProfileImageID} key={`smallImg-${index}`} /> :
                                                <Avatar size={100} icon={<Person />} />
                                            }
                                        </div>
                                        <div style={{ marginLeft: 5, width: 100 }}>
                                            <div className="TextOverflow">{`${timecard.FirstName} ${timecard.LastName}`}</div>
                                            <div className="TextOverflow">{`#${timecard.ClockPin}`}</div>
                                        </div>
                                    </div>
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 30, paddingLeft: 0, paddingRight: 0 }}>
                                    <ExternalLink url={"/user-details/" + timecard.UserId + "/" + userHelper.getValidSubPages()[0]} />
                                </TableRowColumn>
                                <TableRowColumn style={{ width: 30, paddingLeft: 0, paddingRight: 0 }}>
                                    <ImageTimer
                                        hoverColor="#9E9E9E"
                                        onClick={() => props.handleOpenTimecardPopup(timecard.UserId)}
                                    />
                                </TableRowColumn>
                                <TableRowColumn style={{ textAlign: "left", paddingLeft: 10, paddingRight: 0 }}>
                                    <ConsolidatedTimecardEmployeeInnerTable
                                        timecard={timecard}
                                    />
                                </TableRowColumn>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>
        </div>
    )
}

export default ConsolidatedTimecardEmployeeTable